import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import clickableRowProps from '../../../helpers/a11y/clickableRowProps';

// One row in an "Add X" chooser modal that points at a specific parent
// portfolio. The parent page is expected to resolve `portfolioName` itself
// (typically via one `useFirestoreAllIn('CompagnyMeta', 'CompagnyID', parentIds)`
// fetch shared across all chooser rows) and pass it down — so we don't open
// N listeners for N parents.
//
// Use one card per parent in the chooser. Title and subtitle are derived
// from `itemNoun` (e.g. 'Effecten', 'Activiteiten', 'Doelgroepen') and
// `itemNounLower` (e.g. 'effecten', 'activiteiten', 'doelgroepen').
const PortfolioChooserOption = ({ portfolioId, portfolioName, itemNoun, itemNounLower, onClick }) => {
    const name = portfolioName || portfolioId;

    return (
        <div className="options-modal-item" {...clickableRowProps(onClick)}>
            <div className="options-modal-item__icon options-modal-item__icon--portfolio">
                <BusinessCenterOutlinedIcon />
            </div>
            <div className="options-modal-item__body">
                <p className="options-modal-item__title">{itemNoun} uit {name} koppelen</p>
                <p className="options-modal-item__description">
                    Koppel {itemNounLower} van {name}, zodat de resultaten ook in {name} zichtbaar zijn.
                </p>
            </div>
            <ChevronRightIcon className="options-modal-item__chevron" />
        </div>
    );
};

export default PortfolioChooserOption;
